"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import type React from "react";
import {
	Pagination as PaginationComponent,
	PaginationContent,
	PaginationEllipsis,
	PaginationItem,
	PaginationLink,
	PaginationNext,
	PaginationPrevious,
} from "@/components/ui/pagination";
import { cn } from "@/utilities/ui";
import "./pagination.scss";

export const Pagination: React.FC<{
	className?: string;
	page: number;
	totalItems: number;
	itemsPerPage: number;
	onPageChange: (page: number) => void;
}> = ({ className, page, totalItems, itemsPerPage, onPageChange }) => {
	const totalPages = Math.ceil(totalItems / itemsPerPage);

	const hasNextPage = page < totalPages;
	const hasPrevPage = page > 1;

	const hasExtraPrevPages = page - 1 > 1;
	const hasExtraNextPages = page + 1 < totalPages;

	if (totalPages <= 1) {
		return null;
	}

	return (
		<div className={cn(className)}>
			<PaginationComponent>
				<PaginationContent>
					<PaginationItem className="pagination__item previous">
						<PaginationPrevious
							className="arrow"
							disabled={!hasPrevPage}
							onClick={() => {
								onPageChange(page - 1);
							}}
						/>
					</PaginationItem>

					{hasExtraPrevPages && (
						<PaginationItem>
							<PaginationEllipsis />
						</PaginationItem>
					)}

					{hasPrevPage && (
						<PaginationItem className="pagination__item">
							<PaginationLink
								onClick={() => {
									onPageChange(page - 1);
								}}
							>
								{page - 1}
							</PaginationLink>
						</PaginationItem>
					)}

					<PaginationItem className="pagination__item">
						<PaginationLink
							isActive
							onClick={() => {
								onPageChange(page);
							}}
						>
							{page}
						</PaginationLink>
					</PaginationItem>

					{hasNextPage && (
						<PaginationItem className="pagination__item">
							<PaginationLink
								onClick={() => {
									onPageChange(page + 1);
								}}
							>
								{page + 1}
							</PaginationLink>
						</PaginationItem>
					)}

					{hasExtraNextPages && (
						<PaginationItem className="pagination__item">
							<PaginationEllipsis />
						</PaginationItem>
					)}

					<PaginationItem className="pagination__item next">
						<PaginationNext
							className="arrow"
							disabled={!hasNextPage}
							onClick={() => {
								onPageChange(page + 1);
							}}
						/>
					</PaginationItem>
				</PaginationContent>
			</PaginationComponent>
		</div>
	);
};
